module.exports = __webpack_public_path__ + "static/media/heartCondition.f327d76f.mp3";